import { TimePicker } from 'antd';
import styled from 'styled-components';

export const borderColor = '#d9d9d9';
export const blueBorderColor = '#40a9ff';
export const blackBorderColor = '#000';
export const focusBoxShadow = '0 0 0 2px rgba(24, 144, 255, 0.2)';
export const fontSize = '14px';
export const smallerFontSize = '12px';
export const lighterRed = '#ff4d4f';

export const ChargingProfileFormWrapper = styled.div`
  form {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    label:first-child {
      margin-right: 10px;
    }

    button {
      margin-top: 20px;
    }
  }
`;

export const FormLabel = styled.label`
  text-align: right;
  font-size: ${fontSize};
  font-weight: bold;

  &.intervals-label {
    text-align: left;
  }
`;

export const FormInputWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 350px;

  select {
    padding: 4px 20px 4px 8px;
    border: 1px solid ${borderColor};
    border-radius: 2px;
    touch-action: manipulation;
    appearance: none;
    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' standalone='no'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg t='1597601650772' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='1210' xmlns:xlink='http://www.w3.org/1999/xlink' width='16' height='16'%3E%3Cdefs%3E%3Cstyle type='text/css'%3E%3C/style%3E%3C/defs%3E%3Cpath d='M726.652801 429.305603 297.347199 429.305603 512.193405 638.156258Z' p-id='1211'%3E%3C/path%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right;

    &:focus {
      border-color: ${blueBorderColor};
      border-right-width: 1px;
      outline: 0;
      -webkit-box-shadow: ${focusBoxShadow};
      box-shadow: ${focusBoxShadow};
    }

    &:hover {
      border-color: ${blueBorderColor};
      border-right-width: 1px;
    }
  }

  input:hover,
  input:focus,
  input:active,
  input:disabled:hover,
  .ant-input-affix-wrapper:hover,
  .ant-input-affix-wrapper:focus,
  .ant-input-affix-wrapper:active,
  .ant-input-affix-wrapper:visited,
  .ant-input-affix-wrapper-focused,
  select:hover,
  select:focus,
  select:active,
  textarea:hover,
  textarea:focus,
  textarea:active {
    border-right-width: 0 !important;
    border-color: ${blueBorderColor};
    outline: none;
    box-shadow: none;
  }

  input:disabled:hover {
    border-color: rgba(0, 0, 0, 0.3);
  }

  .ant-input-affix-wrapper {
    border-right-width: 0 !important;
  }

  input,
  .ant-input-affix-wrapper,
  select,
  textarea {
    font-size: ${fontSize};
    font-weight: normal;
    border-radius: 0 0 1px 0;
    border-width: 0 0 1px 0;
    border-color: ${blackBorderColor};
  }

  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .intervals-input {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 35px;
    border-color: transparent;
  }

  /* @media (min-width: 1024px) {
    input:not([type='checkbox']) {
      min-width: 300px;
    }
  } */
`;

export const FormInputGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;
  gap: 35px;
`;

export const StyledTimePicker = styled(TimePicker.RangePicker)`
  border-radius: 0 0 1px 0;
  border-width: 0 0 1px 0;
  border-color: ${blackBorderColor};
`;

export const MessageBox = styled.div`
  color: red;
  font-size: ${smallerFontSize};
`;
